import * as React from "react";
import Modal from "antd/lib/modal/Modal";
import { TTranslate } from "../../../core/service/locale/TranslationService";
import { Transfer } from "antd";

export interface State {}

export interface Props {
  modalVisible: boolean;
  translate: TTranslate;
  onChangeModalVisible: any;
  indexGroups;
  currentGroupChildGroups: any;
  assignChildGroups: any;
  finishAssigningGroups: any;
}

export default class TransferListGroupChildModal extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      modalVisible,
      translate,
      onChangeModalVisible,
      indexGroups,
      currentGroupChildGroups,
      assignChildGroups,
      finishAssigningGroups
    } = this.props;

    return (
      <Modal
        visible={modalVisible}
        title={translate("editors.index_type_groups.transfer_groups.title")}
        okText={translate("data_grid.modal.actions.accept")}
        cancelText={translate("data_grid.modal.actions.cancel")}
        onCancel={() => onChangeModalVisible(false, null)}
        onOk={() => finishAssigningGroups()}
        closable={true}
        maskClosable={true}
      >
        <Transfer
          rowKey={(record) => record.id}
          showSearch={true}
          dataSource={indexGroups}
          targetKeys={currentGroupChildGroups}
          render={(item) => item.name}
          onChange={(targetKeys) => assignChildGroups(targetKeys)}
          locale={{
            searchPlaceholder: translate(
              "editors.index_type_groups.transfer_groups.search"
            ),
            notFoundContent: translate("user.transfer.no_data")
          }}
          // selectAllLabels={[
          //   <span style={{ fontWeight: "bold" }}>
          //     {translate("user.transfer.item_unit")}
          //   </span>,
          //   <span style={{ fontWeight: "bold" }}>
          //     {translate("user.transfer.items_unit")}
          //   </span>
          // ]}
          className={"png-transfer"}
        />
      </Modal>
    );
  }
}
